import React from 'react';

export default function usePostMessage() {
  const [properties, setProperties] = React.useState<{
    [key: string]: unknown;
  }>();
  const postMessageHandler = (e: MessageEvent<string>) => {
    try {
      if (typeof e.data === 'string') {
        const data = JSON.parse(e.data) as { [key: string]: unknown };
        if (data.type === 'market') setProperties(data);
      }
    } catch (err) {
      setProperties(undefined);
    }
  };
  React.useEffect(() => {
    window.addEventListener('message', postMessageHandler, false);
    return () => window.removeEventListener('message', postMessageHandler);
  }, []);

  return properties;
}
